export let questionFormSubmit = pageBootstrap => {
  $('.form').on('ajax:complete', function() {
    pageBootstrap();
  })
}
